import { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import CoralButton from '../shared/button/CoralButton';
import {
  SUBSCRIBE_WITHOUT_PAYMENT_ERROR,
  SUBSCRIBE_WITHOUT_PAYMENT_LOADING,
  SUBSCRIBE_WITHOUT_PAYMENT_RETRY_BUTTON_LABEL,
} from '../../constants/localizations/subscription';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import { selectIsUserSubscribed } from '../../selectors/me';
import css from './no-payment-flow.module.scss';

class NoPaymentFlow extends Component {
  static propTypes = {
    selectedProduct: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func.isRequired,
    onSubmitFailure: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    hasFailed: PropTypes.bool.isRequired,
    isSubscriptionComplete: PropTypes.bool.isRequired,
  };

  static contextType = LocationAndLocalizationContext;

  constructor(props) {
    super(props);
    this.retryOnClick = this.retryOnClick.bind(this);
  }

  componentDidMount() {
    this.props.onSubmit(this.props.selectedProduct);
  }

  componentDidUpdate(prevProps) {
    const { isSubscriptionComplete, onSubmitSuccess } = this.props;
    if (isSubscriptionComplete && !prevProps.isSubscriptionComplete) {
      onSubmitSuccess();
    }
  }

  retryOnClick() {
    const { onSubmit, selectedProduct } = this.props;
    onSubmit(selectedProduct);
  }

  render() {
    const { isLoading, hasFailed } = this.props;
    const { getLocalizedText } = this.context;

    if (hasFailed && !isLoading) {
      return (
        <div>
          <h3 className={css.failText}>
            {getLocalizedText(SUBSCRIBE_WITHOUT_PAYMENT_ERROR)}
          </h3>
          <CoralButton
            className={css.retryButton}
            id="retrySubmission"
            label={getLocalizedText(
              SUBSCRIBE_WITHOUT_PAYMENT_RETRY_BUTTON_LABEL,
            )}
            onClick={this.retryOnClick}
          />
        </div>
      );
    }

    if (isLoading) {
      return <h1>{getLocalizedText(SUBSCRIBE_WITHOUT_PAYMENT_LOADING)}</h1>;
    }

    return null;
  }
}

export function mapStateToProps(state) {
  const isLoading = get(
    state,
    'subscription.tuneinSubscription.isFetching',
    false,
  );
  const hasFailed = get(
    state,
    'subscription.tuneinSubscription.hasFailed',
    false,
  );
  const isSubscriptionComplete = selectIsUserSubscribed(state);
  return {
    isLoading,
    hasFailed,
    isSubscriptionComplete,
  };
}

export default connect(mapStateToProps)(NoPaymentFlow);
